import { evaluateTemplateValue } from "@ea-lab/reactive-json";
import { buildCsv } from "./csv";
import { safeFileName } from "../../../utils/fileName";

/**
 * Export CSV des lignes AFFICHÉES d'un tableau.
 *
 * Pourquoi une réaction (échappatoire config-first) : le YAML ne fabrique pas de
 * fichier. Transformer une liste du store en texte tabulé puis en téléchargement
 * passe par `Blob` et un lien créé à la volée — deux API du navigateur qu'aucune
 * action reactive-json n'expose. Rien d'autre n'est codé ici : QUELLES lignes et
 * QUELLES colonnes restent déclarées par l'écran.
 *
 * YAML usage :
 *   - what: downloadCsv
 *     on: click
 *     from: ~~.pages.contents              # la liste (tableau d'objets)
 *     filename: "pages-echantillon"        # sans extension
 *     columns:                             # une entrée par colonne
 *       - { label: "Page", path: "page_label" }
 *       - { label: "Performance", path: "scores.perf" }
 *
 * - `path` est un chemin POINTÉ dans la ligne (`a.b.0.c`).
 * - Une valeur tableau est jointe par « , » ; un objet est sérialisé en JSON.
 * - `from` peut aussi désigner un objet de buckets nommés : ses VALEURS sont
 *   exportées (même tolérance que `shapeFromSpec`).
 * - Liste vide ou colonnes absentes : aucun fichier n'est produit.
 *
 * Le fichier sort en UTF-8 avec BOM et séparateur « ; » — ce qu'un tableur
 * configuré en français ouvre sans assistant d'import. Voir csv.js.
 *
 * Enregistrée dans [App.jsx](../../../App.jsx) sous `customPlugins.reaction.downloadCsv`.
 */
export const downloadCsvReaction = (props) => {
  const { args, globalDataContext, templateContext } = props;
  if (!args) return;

  const gdc = globalDataContext?.getRootContext
    ? globalDataContext.getRootContext()
    : globalDataContext;
  const resolve = (v) =>
    evaluateTemplateValue({ valueToEvaluate: v, globalDataContext: gdc, templateContext });

  const source = resolve(args.from);
  const rows = Array.isArray(source)
    ? source
    : source && typeof source === "object"
      ? Object.values(source)
      : [];
  const columns = Array.isArray(args.columns)
    ? args.columns.filter((c) => c && typeof c.path === "string" && c.path !== "")
    : [];
  if (!rows.length || !columns.length) return;

  const csv = buildCsv(rows, columns);
  const name = safeFileName(resolve(args.filename));
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${name}.csv`;
  link.click();
  // Libéré au tour suivant : certains navigateurs lisent l'URL après le clic.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
